<template>
  <b-row class="no-activity-container">
    <b-col sm="12">
      <h3>{{ title }}</h3>
    </b-col>
    <b-col sm="12">
      <p>{{ body }}</p>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'NoLicenseActivity',
    props: {
      mode: {
        type: String,
        required: true
      }
    },
    computed: {
      title () {
        switch (this.mode) {
          case 'newPurchases':
            return this.$t('noNewPurchasesTitle')
          case 'expiringLicenses':
            return this.$t('noExpiringLicensesTitle')
          default:
            return this.$t('noLicenseActivityTitle')
        }
      },
      body () {
        switch (this.mode) {
          case 'newPurchases':
            return this.$t('noNewPurchasesBody')
          case 'expiringLicenses':
            return this.$t('noExpiringLicensesBody')
          default:
            return this.$t('noLicenseActivityBody')
        }
      }
    }
  }
</script>


<style lang="scss">
  @import '../styles/variables.scss';

  .no-activity-container {
    background-color: $success;
    padding: 20px 0;
    color: $white;
    margin-top: 20px;
    margin-bottom: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/components/NoLicenseActivity.vue